export default __webpack_public_path__ + "static/media/arrow_left.c9235d87.svg";